export default __webpack_public_path__ + "media/images/brighteon-social/tutorial/Brighteon-Social-New-Post-Poll-dbfcb11b9c65c575cdedfaefba30a534.png";